<template>
  <section>
    <p v-if="displayError" class="error-box"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> {{ displayError }}</p>
    <section>
      <h2>Měsíc připojení zdarma pro Vás i pro nového zákazníka</h2>
      <p>
        Jste s našim připojením spokojeni? Řekněte to sousedům, známým, kolegům.
        <b>Za každého nového zákazníka získáte 1 měsíc připojení zdarma.</b>
      </p>
      <p>
        Nový, Vámi doporučený zákazník také získá uvítací bonus: <b>první měsíc připojení také zcela zdarma.</b>
      </p>

      <h2>Jak na to?</h2>
      <p>
        Stačí předat novému zákazníkovi Váš kód doporučení (promo kód).
      </p>
      <div class="alert alert-info">
        Kód pro připojení rychlydrat.cz s prvním měsícem zdarma: <code><b>{{$store.state.customerInfo && $store.state.customerInfo.referral_code}}</b></code>.
        Uveďte prosím nejpozději při podpisu smlouvy.
      </div>
      <p>
        Pak už vše funguje již automaticky. Pokud nový zákazník uvede tento promokód při uzavření smlouvy, tak:
        <ul>
          <li>Vy v příštím měsíčním vyúčtování budete mít slevu odpovídající 100% paušálu za pripojení k internetu.</li>
          <li>Nový zákazník obdrží první měsíc připojení k internetu zdarma.</li>
        </ul>
      </p>

      <h2>Je dobré vědět</h2>
      <p>
        <ul>
          <li>Měsíc zdarma se vztahuje na služby připojení k internetu. Neplatí pro doplňkové placené služby (televize, telefon, veřejná IP).</li>
          <li>Zákazník, který v dané lokalitě využíval připojení k internetu od společnosti Rychlý drát, nebo který žije nebo žil v domácnosti s jinou osobou využívající v dané lokalitě připojení k internetu od společnosti Rychlý drát, nebo právnická osoba spřízněná s takovým zákazníkem, není považován za nového zákazníka. Slevu nelze čerpat při převodu připojení z jednoho místa na druhé.</li>
          <li>V případě, pokud nový zákazník neuhradí ani jeden kalendářní měsíc připojení k internetu, nepřísluší doporučujícímu zákazníkovi sleva na připojení k internetu za doporučení nového zákazníka.</li>
          <li>Podmínky jsou platné ke dni 1.2.2022, společnost Rychlý drát si vyhrazuje právo tyto podmínky měnit.</li>
        </ul>
      </p>

      <h2>Získané odměny</h2>
      <table class="table table-bordered" v-if="referralList">
        <tr>
          <th>datum doporučení</th>
          <th>zákazník</th>
          <th>vaše odměna</th>
          <th>datum odměny</th>
        </tr>

        <tr v-for="referral, index of referralList" :key="index">
          <td nowrap>{{human_readable_date(referral.created_at_date)}}</td>
          <td nowrap>{{referral.new_customer_name}}</td>
          <td nowrap>{{referral.reward_text}}</td>
          <td nowrap>
            <span v-if="referral.rewarded_at">{{human_readable_date(referral.rewarded_at)}}</span>
            <span v-else><i>v příštím účtovacím období</i></span>
          </td>
        </tr>
        <tr v-if="referralList && referralList.length == 0">
          <td colspan="4">
            <i>-- jestě žádné --</i>
          </td>
        </tr>
      </table>
    </section>
  </section>
</template>

<script>
import CustomerResource from '../backend-resources/customer-resource'
import moment from 'moment'

export default {
  data () {
    return {
      referralList: undefined,
      displayError: null
    }
  },
  created: function () {
    CustomerResource.getReferrals().then((response) => {
      this.referralList = response.data
      this.displayError = null
    }).catch((error) => {
      this.displayError = error.response.status + ' ' + error.response.statusText
    })
  },
  methods: {
    human_readable_date: function (yyyymmdd) {
      let m = moment(yyyymmdd)
      return m.isValid() ? m.format('D.M.Y') : yyyymmdd
    }
  }
}

</script>
<style>
</style>



// WEBPACK FOOTER //
// ReferralInfo.vue?6ebbd740